import Select from '@/components/public/ui/Select';

interface YearFilterProps {
  years: number[];
  active: number | null;
  onChange: (year: number | null) => void;
  label?: string;
  className?: string;
}

export default function YearFilter({
  years,
  active,
  onChange,
  label = 'Ano',
  className = '',
}: YearFilterProps) {
  return (
    <Select
      value={active != null ? String(active) : ''}
      onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
      className={className}
    >
      <option value="">{label} (Todos)</option>
      {years.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
    </Select>
  );
}
